// data that presumable will coming from backend services

// mapping of featureValueIds to colour hexValues
// used in middleware to augment the responses
export const colourMapping = {
	SeluxGraphite: '#555',
	BlackMattTiger059: '#333',
	SandMat: '#C6C0A8',
	ClayMat: '#A09576',
	ConcreteGrayMat: '#999',
	JetBlackRAL9005: '#0A0A0A',
	AnthraciteGreyRAL7016: '#293133',
	GraphiteGreyRAL7024: '#474A51',
	IronGreyRAL7011: '#434B4D',
	GreyAluminiumRAL9007: '#8F8F8F',
	WhiteAluminiumRAL9006: '#A5A5A5',
	PureWhiteRAL9010: '#fff',
	TrafficWhiteRAL9016: '#F6F6F6',
	PineGreenRAL6009: '#31372B',
	MossGreenRAL6005: '#2F4538',
	SapphireBlueRAL5003: '#1D1E33',
	WineRedRAL3005: '#5E2129',
	PearledDarkGreyDB703: '#575556',
	PearledSilverGreyDB702: '#777',
	WhiteAluminiumPerlDB701: '#A5A5A5',
	Custom: 'custom',
	StandardColourOfChoice: 'StandardColourOfChoice',
	Gold: '#f1c680',
	Silver: '#e1eef6',
	Black: '#000000'
};

// mapping of featureIds to displayStyles
// used in middleware to augment the responses
export const displayStyleMapping = {
	external: {
		HS_ModuleCutoutSize_1: 'compactSelect',
		HS_ModuleCutoutSize_2: 'compactSelect',
		HS_HousingHeight: 'compactSelect',
		EB_ConstantLumenTechnology_1: 'compactSelect',
		EB_ConstantLumenTechnology_2: 'compactSelect',
		EB_ElectricalProtectionClass_1: 'compactSelect',
		EB_ElectricalProtectionClass_2: 'compactSelect',
		HS_HousingColour: 'colorSelect',
		LE_ReflectorColour_1: 'colorSelect',
		LE_ReflectorColour_2: 'colorSelect',
		LE_DimmingLevel_1: 'reducedSelect',
		LE_DimmingLevel_2: 'reducedSelect',
		HS_HousingPowerConnection: 'reducedSelect',
		LE_LightDistribution_1: 'reducedSelect',
		LE_LightDistribution_2: 'reducedSelect',
		LE_LuminairePositionHeight_1: 'compactSelect',
		LE_LuminairePositionHeight_2: 'compactSelect',
		LE_LuminairePositionHeightSU_1: 'compactSelect',
		LE_LuminairePositionHeightSU_2: 'compactSelect'
	},
	internal: {
		HS_ModuleCutoutSize_1: 'compactSelect',
		HS_ModuleCutoutSize_2: 'compactSelect',
		HS_HousingHeight: 'compactSelect',
		EB_ConstantLumenTechnology_1: 'compactSelect',
		EB_ConstantLumenTechnology_2: 'compactSelect',
		EB_ElectricalProtectionClass_1: 'compactSelect',
		EB_ElectricalProtectionClass_2: 'compactSelect',
		HS_HousingColour: 'comboSelect',
		LE_ReflectorColour_1: 'colorSelect',
		LE_ReflectorColour_2: 'colorSelect',
		LE_DimmingLevel_1: 'reducedSelect',
		LE_DimmingLevel_2: 'reducedSelect',
		HS_HousingPowerConnection: 'reducedSelect',
		LE_LightDistribution_1: 'reducedSelect',
		LE_LightDistribution_2: 'reducedSelect',
	}
};

// mapping of featureIds to displayStyles
// used in middleware to augment the responses
export const regionMapping = {
	HS_LightEmission: {
		// excludeRegions: null,
		// includeRegions: null,
		values: {
			ConformeArrete: {
				// excludeRegions: null,
				includeRegions: 'fra'
			}
		}
	}
};
